import { LARGE_SCREEN, MEDIUM_SCREEN } from '../../../../hooks/useViewport'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Text } from '../../..'
import { HomebotListingsButton } from '../../../buyers/Button/HomebotListingsButton/HomebotListingsButton'
import { ListingsCarousel } from '../../ListingsCarousel'
import { selectHomeAddressState, selectZipcode } from '../../../../store/selectors/home'
import { selectHomeValue } from '../../../../store/selectors/home/metadata'
import { selectHomebotListingsFeatureEnabled } from '../../../../store/selectors/customerProfile'
import { useViewAllListingsUrl } from '../../../../hooks/listings'
import { listingsSearchCriteria } from '../../../../constants/listings'
import baseStyles from '../MarketSpotlight.module.scss'
import styles from './MarketSimilarHomes.module.scss'
import { GeoAreaLevel, ListingsOrderBy, ListingsOrderDirection } from '../../../../api/gqlaxy/gql/generated/graphql'
import { useGetListingsForArea } from '../../../../hooks/listings/useGetListingsForArea'
import { HOMEOWNER_DIGEST_YOUR_MARKET_PAGE } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MarketSimilarHomes = () => {
  const homeValue = useSelector(selectHomeValue)
  const homeZip = useSelector(selectZipcode)
  const homeState = useSelector(selectHomeAddressState)
  const minPrice = homeValue * listingsSearchCriteria.SIMILAR_HOME_MIN_PRICE_MULTIPLIER
  const maxPrice = homeValue * listingsSearchCriteria.SIMILAR_HOME_MAX_PRICE_MULTIPLIER
  const showHomebotListings = useSelector(selectHomebotListingsFeatureEnabled)

  const { data: listings, refetchListings } = useGetListingsForArea(
    {
      page: 0,
      perPage: listingsSearchCriteria.SIMILAR_HOME_LIMIT,
      sortOrder: { orderBy: ListingsOrderBy.DaysOnMarket, orderDir: ListingsOrderDirection.Asc },
      filters: {
        minPrice,
        maxPrice,
        statuses: ['Active', 'Coming Soon']
      },
      searchArea: {
        geoArea: {
          name: '',
          stateAbbreviation: homeState,
          zipCode: homeZip,
          level: GeoAreaLevel.PostalCode
        }
      }
    },
    { enabled: !!homeState && !!homeZip }
  )

  useEffect(() => {
    refetchListings() // Had to call refetch listings for some reason in order to correctly load listings when navigating away from this page and back again (the listings would sometimes disappear when navigating away from this page and coming back again)
  }, [])

  const listingsSearchUrl = useViewAllListingsUrl({
    zipcode: homeZip,
    minPrice,
    maxPrice
  })

  return (
    <>
      {showHomebotListings && listings && listings.length > 2 && (
        <div className={styles.marketSimilarHomes} data-qa='marketSimilarHomes'>
          <Text size='l' variant='neutralCool' variantCount='900'>
            <FormattedMessage
              id='MarketSpotlight.marketSimilarHomes'
              defaultMessage='Similar homes for sale in your zipcode'
            />
          </Text>
          <Text size='xs' variant='neutralCool' variantCount='700' element='div' className={baseStyles.pill}></Text>
          <ListingsCarousel
            listings={listings}
            lastSlideUrl={listingsSearchUrl}
            tracking={{
              guid: 'rcXUjHfMjMnC2hSrc6CWvR',
              ui_context: HOMEOWNER_DIGEST_YOUR_MARKET_PAGE,
              descriptor: 'Your Market Similar Homes Listing Clicked'
            }}
            responsive={[
              {
                breakpoint: LARGE_SCREEN,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: MEDIUM_SCREEN,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]}
          />
          <HomebotListingsButton className={styles.listingsButton} listingsUrl={listingsSearchUrl}>
            <FormattedMessage
              id='MarketSpotlight.marketSimilarHomes.view.more.button'
              defaultMessage='See all nearby homes'
            />
          </HomebotListingsButton>
        </div>
      )}
    </>
  )
}
